import { useState } from 'react';

import '../components/Admin/TableAdmin.css'
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import '../components/License/ListPageStyles.css'
import { FaKey, FaLink, FaBoxes } from 'react-icons/fa';
import Licenses from '../components/License/LicensePages/Licenses';
import LicenseLinks from '../components/License/LicensePages/LicenseLinks';
import LicenseModels from '../components/License/LicensePages/LicenseModels';
import TabPanel from '../components/TabPanel';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function License() {
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (_, newValue) => {
        setTabIndex(newValue);

    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIndex} onChange={handleChange} aria-label="basic tabs example">
                    <Tab icon={<FaKey />} iconPosition="start" label="Licenças" {...a11yProps(0)} />
                    <Tab icon={<FaLink />} iconPosition="start" label="Licenças Vinculadas" {...a11yProps(1)} />
                    <Tab icon={<FaBoxes />} iconPosition="start" label="Modelos de Licença" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <TabPanel value={tabIndex} index={0} style={{ padding: "5px" }}>
                <Licenses tabIndex={tabIndex} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1} style={{ padding: "5px" }}>
                <LicenseLinks tabIndex={tabIndex} />
            </TabPanel>
            <TabPanel value={tabIndex} index={2} style={{ padding: "5px" }}>
                <LicenseModels tabIndex={tabIndex} />
            </TabPanel>
        </Box>
    )
}